import { createAction, props } from '@ngrx/store';

export const loadDownloadEmployeesUploadedDocument = createAction(
  '[BulkEmployeesUpdateHistory] Load DownloadEmployeesUploadedDocuments',
  props<{ documentName: string; }>()
);

export const loadDownloadEmployeesUploadedDocumentSuccess = createAction(
  '[BulkEmployeesUpdateHistory] Load DownloadEmployeesUploadedDocuments Success',
  props<{ response: any }>()
);

export const loadDownloadEmployeesUploadedDocumentFailure = createAction(
  '[BulkEmployeesUpdateHistory] Load DownloadEmployeesUploadedDocuments Failure',
  props<{ error: Error | any }>()
);
